import axios from 'axios';

import cookie from '../libs/jquery.cookie';
import {getLang} from "../helpers/Helpers";
import * as CoreUI from '../components/UI/coreUI';

import TopMenu from '../components/TopMenu/TopMenu';
import Footer from '../components/Footer/Footer';
import whatsappWidget from '../components/whatsapp/whatsapp';

const Page = module => {
    const setLang = async() => {
        let langAddress = `cache/_translations/${getLang()}-translations.json?v=${Date.now()}`;
        return await axios.get(langAddress);
    };
  
	const init = async() => {
        /*try {
            let lang = await setLang();
    
            localStorage.removeItem('lang');
            localStorage.setItem('lang', JSON.stringify(lang.data));
            this.module();
            
        } catch(e){
        	console.log(e);
        }*/
		
        
        return;
	};
	
	const cookies = () => {
		$('.close-cookie').click(function (e) {
			e.preventDefault();
			var REL = $(this).attr('rel');
			$('#' + REL).delay(1500).hide();
			$.cookie('COOKIE_INFO', 1, {expires: 365, path: '/'});
		});
	}
	
	const boot = () => {
      init().then(() => {
          window.addEventListener('load', module);
      });
    };
	
	boot();
	cookies();
};

export default Page;